import classes from './Draggable.module.css';

import { useDraggable } from "@dnd-kit/core";
import clsx from "clsx";
import Media from "../../Media/Media";

import { STATES } from "react-sdk/activities/ActivityPedaInstance";


import Button from '@/components/shared/Button/Button';
import { FaPlay, FaVolumeHigh } from 'react-icons/fa6';
import PlayAudio from '@/components/shared/PlayAudio/PlayAudio';


const Draggable = ({item, inTarget, dragged=false, showCorrection, disabled=false}) => {

  const {attributes, listeners, setNodeRef, transform} = useDraggable({
    id: item.ID,
    data: {type: item.target},
    disabled
  });

  const style = {
    opacity: transform ? 0.1 : 1
  }


  let correctionState
  if(showCorrection) correctionState = item.getCorrectionState(inTarget)

  let fsMedia = item.media

  if(fsMedia && fsMedia.includes('.')) {
    fsMedia = fsMedia.split('.')
    fsMedia = `${fsMedia[0]}_fs.${fsMedia[1]}`
  }

  return (
    <div className={classes.draggable_ctnr} ref={setNodeRef} style={style} {...listeners} {...attributes}>

      <div className={clsx(
      classes.draggable,
      item.media && classes.with_media,
      item.Audio && classes.with_audio,
      dragged && classes.dragged,
      (showCorrection && correctionState === STATES.CORRECT) && classes.correct,
      (showCorrection && correctionState === STATES.WRONG) && classes.wrong,
      (showCorrection && correctionState === STATES.MISSED) && classes.missed,
      )}>

        {item.media &&
        <div className={classes.media_ctnr}>
          <Media path={item.media} fullscreenPath={fsMedia}/>
        </div>}

        <div className={classes.draggable_content}>
          {item.Audio &&
          <PlayAudio audio={item.Audio} autoplay={dragged}>
            {(playing, handleClick) =>
              <div data-no-dnd onClick={handleClick} className={classes.play_btn}>{playing ? <FaVolumeHigh/> : <FaPlay />}</div>}
          </PlayAudio>}

          {item.Text &&
          <div className={classes.draggable_text} dangerouslySetInnerHTML={{__html: item.Text}}></div>}
        </div>

      </div>
    </div>
  );

}

export default Draggable